/* Shim for deprecated uvoAutocomplete. Only modifies html layout for compatibility */
$.fn.uvoAutocomplete = $.fn.uvoAutocomplete || function() {
  return this.each(function(_, el) {
    if (el.uvoAutocompleteShimInitialized) return;
    el.uvoAutocompleteShimInitialized = true;
    var $el = $(el);
    var $wrapper = $('<div class="uvo_pref-uvoAutocomplete-wrapper" />');
    var $icon = $('<span class="ui-icon ui-icon-triangle-1-s" style="position: absolute; cursor: pointer; right: 10px; top: 0px;" />');
    $el.wrap($wrapper);
    $el.after($icon);
    $el.addClass('uvo_pref-uvoAutocomplete-input');
    $el.css({ appearance: 'none', '::-ms-expand': 'none' });
    $icon.css({ pointerEvents: 'none' });
  })
};


/* =============================
*  NEW CALC INIT
================================ */
$.getScript('/assets/js/calc.js', function () {
  // SHORT CALC
  if ($('[data-calc-short]').length > 0) {
    new Calc({
      ID: '1',
      calculatorType: 'ShortCalculator',
      format: 'json',
      options: {
        deafault: {
          deadlinesDefault: [139971],
          academicLevelDefault: 1,
          paperTypesDefault: 6,
          pagesDefault: 1
        }
      }
    });
  }

  //CALC MINI
  if ($('[data-calc-mini]').length > 0) {
    new Calc({
      ID: '1',
      calculatorType: 'DefaultCalculator',
      format: 'html',
      options: {
        deafault: {
          deadlinesDefault: [139971],
          academicLevelDefault: 1,
          paperTypesDefault: 6,
          pagesDefault: 1
        }
      }
    });
  }
});
/* =============================
*  end NEW CALC INIT
================================ */


/**
 * Description: JS for midterm.us
 * Version: 1.0.0
 * Last update: 2017/11/15
 * Author: UVOCorp
 *
 * Summary:
 *
 *  0. matchMedia() polyfill
 *    - Test a CSS media type/query in JS. Authors & copyright (c) 2012: Scott Jehl, Paul Irish, Nicholas Zakas. Dual MIT/BSD license
 *  1. SpryTabbedPanels.js - Revision: Spry Preview Release 1.4
 *    - Copyright 2006. Adobe Systems Incorporated.
 *  2. Custom JS for midterm.us
 *
 */




/* ==========================================================================
   1. SpryTabbedPanels.js
   ========================================================================== */

var Spry;Spry||(Spry={}),Spry.Widget||(Spry.Widget={}),Spry.Widget.TabbedPanels=function(e,t){if(this.element=this.getElement(e),this.defaultTab=0,this.bindings=[],this.tabSelectedClass="TabbedPanelsTabSelected",this.tabHoverClass="TabbedPanelsTabHover",this.tabFocusedClass="TabbedPanelsTabFocused",this.panelVisibleClass="TabbedPanelsContentVisible",this.focusElement=null,this.hasFocus=!1,this.currentTabIndex=0,this.enableKeyboardNavigation=!0,Spry.Widget.TabbedPanels.setOptions(this,t),"number"==typeof this.defaultTab){if(this.defaultTab<0)this.defaultTab=0;else{var a=this.getTabbedPanelCount();this.defaultTab>=a&&(this.defaultTab=a>1?a-1:0)}this.defaultTab=this.getTabs()[this.defaultTab]}this.defaultTab&&(this.defaultTab=this.getElement(this.defaultTab)),this.attachBehaviors()},Spry.Widget.TabbedPanels.prototype.getElement=function(e){return e&&"string"==typeof e?document.getElementById(e):e},Spry.Widget.TabbedPanels.prototype.getElementChildren=function(e){for(var t=[],a=e.firstChild;a;)1==a.nodeType&&t.push(a),a=a.nextSibling;return t},Spry.Widget.TabbedPanels.prototype.addClassName=function(e,t){!e||!t||e.className&&-1!=e.className.search(new RegExp("\\b"+t+"\\b"))||(e.className+=(e.className?" ":"")+t)},Spry.Widget.TabbedPanels.prototype.removeClassName=function(e,t){!e||!t||e.className&&-1==e.className.search(new RegExp("\\b"+t+"\\b"))||(e.className=e.className.replace(new RegExp("\\s*\\b"+t+"\\b","g"),""))},Spry.Widget.TabbedPanels.setOptions=function(e,t,a){if(t)for(var n in t)a&&void 0==t[n]||(e[n]=t[n])},Spry.Widget.TabbedPanels.prototype.getTabGroup=function(){if(this.element){var e=this.getElementChildren(this.element);if(e.length)return e[0]}return null},Spry.Widget.TabbedPanels.prototype.getTabs=function(){var e=[],t=this.getTabGroup();return t&&(e=this.getElementChildren(t)),e},Spry.Widget.TabbedPanels.prototype.getContentPanelGroup=function(){if(this.element){var e=this.getElementChildren(this.element);if(e.length>1)return e[1]}return null},Spry.Widget.TabbedPanels.prototype.getContentPanels=function(){var e=[],t=this.getContentPanelGroup();return t&&(e=this.getElementChildren(t)),e},Spry.Widget.TabbedPanels.prototype.getIndex=function(e,t){if(e=this.getElement(e),e&&t&&t.length)for(var a=0;a<t.length;a++)if(e==t[a])return a;return-1},Spry.Widget.TabbedPanels.prototype.getTabIndex=function(e){var t=this.getIndex(e,this.getTabs());return 0>t&&(t=this.getIndex(e,this.getContentPanels())),t},Spry.Widget.TabbedPanels.prototype.getCurrentTabIndex=function(){return this.currentTabIndex},Spry.Widget.TabbedPanels.prototype.getTabbedPanelCount=function(){return Math.min(this.getTabs().length,this.getContentPanels().length)},Spry.Widget.TabbedPanels.addEventListener=function(e,t,a,n){try{e.addEventListener?e.addEventListener(t,a,n):e.attachEvent&&e.attachEvent("on"+t,a)}catch(s){}},Spry.Widget.TabbedPanels.prototype.onTabClick=function(e,t){this.showPanel(t)},Spry.Widget.TabbedPanels.prototype.onTabMouseOver=function(e,t){this.addClassName(t,this.tabHoverClass)},Spry.Widget.TabbedPanels.prototype.onTabMouseOut=function(e,t){this.removeClassName(t,this.tabHoverClass)},Spry.Widget.TabbedPanels.prototype.onTabFocus=function(){this.hasFocus=!0,this.addClassName(this.element,this.tabFocusedClass)},Spry.Widget.TabbedPanels.prototype.onTabBlur=function(){this.hasFocus=!1,this.removeClassName(this.element,this.tabFocusedClass)},Spry.Widget.TabbedPanels.ENTER_KEY=13,Spry.Widget.TabbedPanels.SPACE_KEY=32,Spry.Widget.TabbedPanels.prototype.onTabKeyDown=function(e,t){var a=e.keyCode;return!this.hasFocus||a!=Spry.Widget.TabbedPanels.ENTER_KEY&&a!=Spry.Widget.TabbedPanels.SPACE_KEY?!0:(this.showPanel(t),e.stopPropagation&&e.stopPropagation(),e.preventDefault&&e.preventDefault(),!1)},Spry.Widget.TabbedPanels.prototype.preorderTraversal=function(e,t){var a=!1;if(e&&(a=t(e),e.hasChildNodes()))for(var n=e.firstChild;!a&&n;){a=this.preorderTraversal(n,t);try{n=n.nextSibling}catch(s){n=null}}return a},Spry.Widget.TabbedPanels.prototype.addPanelEventListeners=function(e){var t=this;if(Spry.Widget.TabbedPanels.addEventListener(e,"click",function(a){return t.onTabClick(a,e)},!1),Spry.Widget.TabbedPanels.addEventListener(e,"mouseover",function(a){return t.onTabMouseOver(a,e)},!1),Spry.Widget.TabbedPanels.addEventListener(e,"mouseout",function(a){return t.onTabMouseOut(a,e)},!1),this.enableKeyboardNavigation){var a=null,n=null;this.preorderTraversal(e,function(t){if(1==t.nodeType){var s=e.attributes.getNamedItem("tabindex");if(s)return a=t,!0;n||"a"!=t.nodeName.toLowerCase()||(n=t)}return!1}),a?this.focusElement=a:n&&(this.focusElement=n),this.focusElement&&(Spry.Widget.TabbedPanels.addEventListener(this.focusElement,"focus",function(a){return t.onTabFocus(a,e)},!1),Spry.Widget.TabbedPanels.addEventListener(this.focusElement,"blur",function(a){return t.onTabBlur(a,e)},!1),Spry.Widget.TabbedPanels.addEventListener(this.focusElement,"keydown",function(a){return t.onTabKeyDown(a,e)},!1))}},Spry.Widget.TabbedPanels.prototype.showPanel=function(e){var t=-1;if(t="number"==typeof e?e:this.getTabIndex(e),!(0>!t||t>=this.getTabbedPanelCount())){for(var a=this.getTabs(),n=this.getContentPanels(),s=Math.max(a.length,n.length),i=0;s>i;i++)i!=t&&(a[i]&&this.removeClassName(a[i],this.tabSelectedClass),n[i]&&(this.removeClassName(n[i],this.panelVisibleClass),n[i].style.display="none"));this.addClassName(a[t],this.tabSelectedClass),this.addClassName(n[t],this.panelVisibleClass),n[t].style.display="block",this.currentTabIndex=t}},Spry.Widget.TabbedPanels.prototype.attachBehaviors=function(){for(var e=this.getTabs(),t=this.getContentPanels(),a=this.getTabbedPanelCount(),n=0;a>n;n++)this.addPanelEventListeners(e[n],t[n]);this.showPanel(this.defaultTab)};

/* ==========================================================================
   2. Custom JS for midterm.us
   ========================================================================== */
/*
   Toggle list
========================================================================== */
$('.pricing-page .toggle-list .toggle-content').addClass('hide');
$(document).on('click', '.pricing-page .toggle-list .toggle-link', function(){
  if($(this).next().hasClass('hide')){ $(this).next().slideDown(500); }else{ $(this).next().slideUp(500); }
  $(this).parent().toggleClass('active');
  $(this).next().toggleClass('hide');
  return false;
});



$(function() {
if( !$('body').hasClass('orderform-page') &&  !$('body').hasClass('rc-cabinet')  ) {
	//add class "selected" for item select
	$('form.place-your-order').find('.selectbox').uvoAutocomplete({
		sortBy: 'none',
		onOpen: function(e) {
			var lebelEl = this.label;
			$(this._listElement.children()).each(function() {
				if ($(this).text() == lebelEl) {
					$(this).addClass('selected')
				}
			});
		}
	});
	//count pages
	$.fn.counts = function(options) {
			//defaultOptions
			options = $.extend({
				minusClass: 'pageskol-left',
				minimum: 1
			}, options);
			var inputCol = $(this);
			if ($(inputCol).val() <= options.minimum) {
				$('span[class=' + options.minusClass + ']').css({
					'opacity': '0.5',
					'cursor': 'default'
				});
			} else {
				$('span[class=' + options.minusClass + ']').css({
					'opacity': '1',
					'cursor': 'pointer'
				});
			}
			$(inputCol).parent().find('span').click(function() {
				if ($(this).hasClass(options.minusClass)) {
					if ($(inputCol).val() >= options.minimum) {
						var count = parseInt($(inputCol).val()) - 1;
						count = count < options.minimum ? options.minimum : count;
					} else {
						$(inputCol).val(options.minimum - 1);
						var count = parseInt($(inputCol).val()) - 1;
						count = count < options.minimum ? options.minimum : count;
					}
					if ($(inputCol).val() <= (options.minimum + 1)) {
						$('span[class=' + options.minusClass + ']').css({
							'opacity': '0.5',
							'cursor': 'default'
						});
					}
				} else {
					if ($(inputCol).val() >= options.minimum) {
						var count = parseInt($(inputCol).val()) + 1;
					} else {
						$(inputCol).val(options.minimum - 1);
						var count = parseInt($(inputCol).val()) + 1;
					}
					if ($(inputCol).val() > (options.minimum - 1)) {
						$('span[class=' + options.minusClass + ']').css({
							'opacity': '1',
							'cursor': 'pointer'
						})
					}
				}
				$(inputCol).val(count);
				$(inputCol).change();
				$(this).parent().next().find('span').html(275 * count);
				return false;
			});
			$(this).change(function(e) {
				var count = parseInt($(this).val())
				if (isNaN(count)) {
					count = 1;
					$(this).val(1);
				}
				$(this).parent().next().find('span').html(275 * count);
			});
			$(this).focusout(function(e) {
				var count = parseInt($(this).val())
				if (isNaN(count)) {
					count = 1;
					$(this).val(1);
				}
				$(this).parent().next().find('span').html(275 * count);
			});
			$(this).keydown(function(e) {
				if (e.which != 8 && e.which != 0 && (e.which < 37 || e.which > 57) && e
					.which != 96 && e.which != 97 && e.which != 98 && e.which != 99 && e.which !=
					100 && e.which != 101 && e.which != 102 && e.which != 103 && e.which !=
					104 && e.which != 105) {
					return false;
				}
				var key, keyChar;
				if (!e) var e = window.e;
				if (e.keyCode) key = e.keyCode;
				else if (e.which) key = e.which;
				if (key == 8) {
					return true;
				}
				if (key == 38 || key == 39 || (e.which < 48 || e.which > 57) && e.which !=
					96 && e.which != 97 && e.which != 98 && e.which != 99 && e.which !=
					100 && e.which != 101 && e.which != 102 && e.which != 103 && e.which !=
					104 && e.which != 105) {
					if (key == 40 || key == 37) {
						if ($(this).val() >= options.minimum) {
							var count = parseInt($(this).val()) - 1;
							count = count < options.minimum ? options.minimum : count;
						} else {
							$(this).val(options.minimum - 1);
							keyChar = String.fromCharCode(key);
							var count = parseInt($(this).val()) + 1;
						}
					} else {
						if ($(this).val() >= options.minimum) {
							var count = parseInt($(this).val()) + 1;
						} else {
							$(this).val(options.minimum - 1);
							var count = parseInt($(this).val()) + 1;
						}
					}
					$(this).val(count);
					$(this).parent().next().find('span').html(275 * count);
					if ($(inputCol).val() <= (options.minimum)) {
						$('span[class=' + options.minusClass + ']').css({
							'opacity': '0.5',
							'cursor': 'default'
						});
					} else {
						$('span[class=' + options.minusClass + ']').css({
							'opacity': '1',
							'cursor': 'pointer'
						})
					}
				}
			});
		}
		//counts
	$('#input-kol').counts();
}


	//toplink click
	$('.totop-link').click(function() {
		$('body,html').animate({
			scrollTop: 0
		}, 800);
		return false;
	});


	//password reminder
	//for inquiry page
	$('.show-hide').find('.hidden').hide();
	$('#inq-done-more').click(function() {
		if (!$(this).hasClass('less')) {
			$(this).parents('.show-hide').find('.hidden').slideDown(500);
			$(this).text('Read less').addClass('less');
		} else {
			$(this).parents('.show-hide').find('.hidden').slideUp(500);
			$(this).text('Read more').removeClass('less');
		}
	});
	$('.plagcheckc aside#rightplagpanel').clone().appendTo('.plagcheckc').addClass(
		'rgt-spec-plag').attr('id', 'rightplagpanel_2');
	$("#menu-icon").on("click", function(){
		$("#mnu ul").toggleClass("active");
	});

	//toggle topmenu
	$('.toggle-menu').click(function() {
		$(this).toggleClass('active');
		if ($(this).next().css('display') == 'none') {
			$(this).next().show();
		} else {
			$(this).next().hide();
		}
		return false;
	});
	if ($('.topmenu-line').length > 0) {
		var tmenu = $('.topmenu-line'),
			tmenuTop = $('.topmenu-line').offset().top;
	}
	$(window).scroll(function() {
		//fixed menu
		var scrlTopPos = $(window).scrollTop(),
			windowWidth = parseInt($(window).width()) + 17;
		if (windowWidth >= 968) {
			if (scrlTopPos <= tmenuTop) {
				$(tmenu).removeClass('fixed');
			} else if (scrlTopPos > tmenuTop) {
				$(tmenu).addClass('fixed');
			}
		}
		//show to-top link
		if ($(window).scrollTop() >= 200) {
			$('.totop-link').fadeIn();
		} else {
			$('.totop-link').fadeOut();
		}
	});
});

(function(window, document) {
  function init() {
    window.NotifyWidget({
      siteId: '1',
      container: '.NotifyWidget-banner'
    });
  }

  if (typeof window.NotifyWidget !== 'undefined') {
    init();
  } else {
    const script = document.createElement('script');
    script.src = '/assets/js/notifyWidget.min.js';
    script.async = true;
    script.onload = function () {
      init();
    };
    document.getElementsByTagName('head')[0].appendChild(script);
  }
})(window, document);

(function toggleListInit() {
  if (!document.querySelector('[data-page="frequently_asked_questions"]') && !document.querySelector('[data-page="money_back_guarantee"]')) return false;

  function toggle_list() {
    $('.toggle-list .toggle-content').addClass('hide');
    $(document).on('click', '.toggle-list .toggle-link', function(){
      if($(this).next().hasClass('hide')){ $(this).next().slideDown(500); }else{ $(this).next().slideUp(500); }
      $(this).parent().toggleClass('active');
      $(this).next().toggleClass('hide');
      return false;
    });
  }

  window.addEventListener('contentRendered', toggle_list);
})();
